// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__6uVDO","location":"Header_location__17kP-"};